import { useQuery } from '@tanstack/react-query'

import { OrgBillingAPI } from '@makyoapp/makyo-sdk'

import { fromSdkAddressList, fromSdkPaymentList } from '@/adapters/BillingAdapter'
import { queryKeys } from '@/lib/react-query'
import { useCurrentOrgContext } from '@/context/CurrentOrgContext'

/**
 * Get Org's Payment Methods
 */
export const useGetPaymentMethodList = () => {
  const { currentOrg } = useCurrentOrgContext()
  const orgID = currentOrg?.id

  return useQuery({
    queryKey: [queryKeys.orgPaymentMethodList, orgID],
    queryFn: () => {
      if (!orgID) return
      return OrgBillingAPI.ReqListPaymentMethod(orgID).then(fromSdkPaymentList)
    },
  })
}

/**
 * Get Org's Billing Address
 */
export const useGetAddressList = () => {
  const { currentOrg } = useCurrentOrgContext()
  const orgID = currentOrg?.id

  return useQuery({
    queryKey: [queryKeys.orgBillingAddressList, orgID],
    queryFn: () => {
      if (!orgID) return
      return OrgBillingAPI.ReqListAddress(orgID).then(fromSdkAddressList)
    },
    enabled: !!orgID,
  })
}
